import gql from 'graphql-tag';

export const QUERY_UPRN_PROPERTIES_IN_POSTCODE = gql`
    query addressesByPostcode($postcode: String!) {
        addressesByPostcode(postcode: $postcode) {
            addresses {
                uprn
                postcode
                fullAddress
            }
        }
    }
`;
